export const TabListProperty = {
  Tabs: 'tabs',
  ActiveIndex: 'activeIndex',
};

export const TabProperty = {
  Tab: 'tab',
  ActiveIndex: 'activeIndex',
  Index: 'index',
};

export const TabListEventType = {
  TabChange: 'tabChange',
};
